
import { QueryResultType } from "./QueryResultType";
import { ResultAreaTypeInfo } from "./ResultAreaTypeInfo";
import { ResultLineDataTypeInfo } from "./ResultLineDataTypeInfo";
import { ResultPOITypeInfo } from "./ResultPOITypeInfo";
import { ResultStatisticsTypeInfo } from "./ResultStatisticsTypeInfo";
import { ResultSuggestTypeInfo } from "./ResultSuggestTypeInfo";


export class QueryResultInfoFactory
{   

    /**
	 *获取结果类型 
	 * @param jsonObj
	 * @return 
	 */
	static GetResultType(jsonObj) {
		let resultType = -1;
		if (jsonObj == null) return resultType;
		resultType = jsonObj.resultType;
		return resultType;
	}

	/**
	 *获得查询结果信息 
	 * @param jsonObj Json对象
	 * @return 
	 * 
	 */
	static GetQueryResultInfo(jsonObj) {
		let resultInfo = null;
		if (jsonObj == null) return resultInfo;

		let resultType = QueryResultInfoFactory.GetResultType(jsonObj);

		if (resultType == QueryResultType.Area) {
			resultInfo = ResultAreaTypeInfo.GetResultAreaTypeInfo(jsonObj);
		}
		else if (resultType == QueryResultType.LineData) {
			resultInfo = ResultLineDataTypeInfo.GetResultLineDataTypeInfo(jsonObj);
		}
		else if (resultType == QueryResultType.POI) {
			resultInfo = ResultPOITypeInfo.GetResultPOITypeInfo(jsonObj);
		}
		else if (resultType == QueryResultType.Statistics) {
			resultInfo = ResultStatisticsTypeInfo.GetResultStatisticsTypeInfo(jsonObj);
		}
		else if (resultType == QueryResultType.Suggest) {
			resultInfo = ResultSuggestTypeInfo.GetResultSuggestTypeInfo(jsonObj);
		}

		return resultInfo;
	}

}